export default __webpack_public_path__ + "static/media/apple-touch-icon-76x76.17b9f139.png";